import { render, staticRenderFns } from "./AdditionalFiles.vue?vue&type=template&id=b2078376&"
import script from "./AdditionalFiles.vue?vue&type=script&lang=js&"
export * from "./AdditionalFiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports